/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const KeywordScanCreateUpdateDTOLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const KeywordScanCreateUpdateDTOStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * Check if a given object implements the KeywordScanCreateUpdateDTO interface.
 */
export function instanceOfKeywordScanCreateUpdateDTO(value) {
    return true;
}
export function KeywordScanCreateUpdateDTOFromJSON(json) {
    return KeywordScanCreateUpdateDTOFromJSONTyped(json, false);
}
export function KeywordScanCreateUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'locationUrl': json['locationUrl'] == null ? undefined : json['locationUrl'],
        'filterName': json['filterName'] == null ? undefined : json['filterName'],
        'location': json['location'] == null ? undefined : json['location'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}
export function KeywordScanCreateUpdateDTOToJSON(json) {
    return KeywordScanCreateUpdateDTOToJSONTyped(json, false);
}
export function KeywordScanCreateUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'locationUrl': value['locationUrl'],
        'filterName': value['filterName'],
        'location': value['location'],
        'status': value['status'],
    };
}
